module.exports = __webpack_public_path__ + "static/media/profile-picture-1.dd1281e6.png";